/* eslint-disable no-undef */
/* eslint-disable no-unsafe-optional-chaining */
//types
import { APIResponseTransformer, ListingState } from './types';

//helpers
import Storage from 'shared/helpers/storage';

//constants
import { API_KEYS } from './constants';
import { FILTERS_LS_NAME } from 'shared/layouts/Listing/Desktop/components/Layout/constants';

export const transformApiResult = (
  {
    listingResponse,
    adPlatformResponse,
    currentPage,
    appliedFilters,
    extras,
  }: APIResponseTransformer,
  isFetchingWithFilters: boolean,
  previousData: Partial<ListingState>
) => {
  const payload: any = {
    products: listingResponse?.products || [],
    filters: listingResponse?.filters || [],
    title: listingResponse?.title || '',
    bannerImages: listingResponse?.banner_images || [],
    topCollection: listingResponse?.topCollection || [],
    metaData: listingResponse?.meta_data || {},
    tiptiles: listingResponse?.tiptiles || [],
    uiMessage: listingResponse?.ui_message || '',
    filterGuides: listingResponse?.guides || {},
    categoryURL: listingResponse?.categoryURL || '',
    kidsFilters: listingResponse?.kids_filters || {},
    trackingMetaData: listingResponse?.tracking_metadata || {},
    appliedFilters: appliedFilters || {},
    filterWithNames: extras.filterWithNames,
    isOfferPage: extras.isOfferPage,
    currentPage,
    entityData: {
      entityCoverage: listingResponse.entity_coverage,
      entityType: listingResponse.entity_type,
      entityValues: listingResponse.entity_values,
    },
    breadcrumbs: listingResponse?.breadcrumbs || []
  };

  if (!isFetchingWithFilters && previousData?.products) {
    payload.products = [...previousData.products, ...listingResponse?.products];
  } else {
    payload.products = listingResponse?.products || [];
  }

  if (adPlatformResponse) {
    payload.adPlatformWidgetData = adPlatformResponse;
    payload.adPlatformData = listingResponse.ad_platform_data;
  }

  if (extras.categoryId) payload.categoryId = extras.categoryId;
  if (extras.searchTerm) payload.searchTerm = extras.searchTerm;
  if (extras.isSearch) payload.isSearch = extras.isSearch;
  if (extras.footerHTML !== null) payload.footerHTML = extras.footerHTML;
  if (listingResponse.is_brand) payload.isBrand = true;
  payload.count = listingResponse?.count;
  payload.outOfStockCount = listingResponse?.outOfStockCount || 0;
  if (listingResponse?.store_redirection) payload.store_redirection = listingResponse.store_redirection;
  if (extras.cumulativeOOSCount !== undefined)
    payload.cumulativeOOSCount = extras.cumulativeOOSCount;
  return payload;
};

export const getFilterNames = (
  filters: Listing.IFilter[],
  appliedFilters: Record<string, string>
) => {
  let currentFilters: [] = [];
  if (__BROWSER__) {
    currentFilters = Storage.getItem(FILTERS_LS_NAME) || [];
  }

  // getting filterNames here to get names for this filters which might have not come in store (listingV2.filters)
  // we are creating this to reduce the time complexity of finding a new id in a array of objects
  const filterObject: Record<string, string> = {};
  const valueArray: Record<string, string>[] = [];

  const setFilterObject = (values: Listing.IValue[], key: string) => {
    values.forEach((option) => {
      filterObject[key][option.id] = option;
      if (option.children?.length) setFilterObject(option.children, key);
    });
  };

  filters.forEach((filter) => {
    if (appliedFilters[filter.key] && filter.key !== API_KEYS.PRICE_FILTER) {
      const { key, values } = filter;
      if (filterObject[key] === undefined) filterObject[key] = {};
      setFilterObject(values, key);
    }
  });

  Object.keys(appliedFilters).forEach((filterKey) => {
    if (filterKey === API_KEYS.PRICE_FILTER) {
      valueArray.push({ key: filterKey, name: appliedFilters[filterKey] });
    } else if (filterKey !== API_KEYS.CATALOG_TAG_FILTER) {
      const appliedIds = appliedFilters[filterKey].split('_');
      appliedIds.forEach((id) => {
        const objectToAppend =
          filterObject[filterKey] && filterObject[filterKey][id]
            ? filterObject[filterKey][id]
            : currentFilters.find((value) => value.id === id);

        if (objectToAppend) {
          valueArray.push({ key: filterKey, ...objectToAppend });
        }
      });
    }
  });
  if (__BROWSER__) Storage.setItem(FILTERS_LS_NAME, valueArray);

  return valueArray;
};
